export default {
	// $ 公共
	general_button_cancel: 'Löschen',
	general_button_sure: 'Bestätigen',
	general_button_close: 'Schließen',
	general_text_update_faild: 'Aktualisierung ist fehlgeschlagen',
	general_button_done: 'Fertig',
	general_text_no_data: 'Keinen Termin gefunden ',
	general_text_ordered: 'Bestellt',
	general_text_next_turn_time: 'Gang',
	general_text_get_limit_rule_failed: 'Reihenfolge der Gänge wurde nicht eingehalten',
	general_text_customer_not_exist: 'Nutzer existiert nicht',
	general_text_can_not_get_rules_of_dish: 'Ihre Eingaben sind nicht eingegangen',

	// $ 历史订单
	order_history_page_text_no_make: 'Nicht möglich',
	order_history_page_text_make_complete: 'Wird geliefert',
	order_history_page_text_service_complete: 'Bestellung erfolgreich',
	order_history_page_text_unable_make: 'Gelöscht',
	order_history_page_text_pause_make: 'Unterbrochen',
	order_history_page_text_waiter: 'Kellner',
	order_history_page_text_customer: 'Kunde',
	order_history_page_text_extra: 'Extrakosten',
	order_history_page_text_order_devices: 'Weitere  Geräte',
	history_order_you: 'Kunde',
	history_order_round: 'Die Runde {{round}}',
	history_order_total: 'insgesamt: {{number}} Gerichte',

	// $ 呼叫服务
	service_page_text_call_service_select: 'Service rufen (optional)',
	service_page_text_insert_texts: ' Inhalt eingeben',
	service_page_text_call_waiter: ' Kellner rufen',
	service_page_text_call_service: 'Service rufen',
	service_page_text_table_name: 'Tabellenname',
	service_page_text_Please_select_a_service: 'Wählen Sie einen Dienst',
	service_page_text_Your_requirement: 'Ihre Anforderung (optional)',
    service_page_text_call_service_success_message: 'Erfolg angerufen',
    service_page_input_placeholder_message: 'Geben Sie Ihre Anforderungen ein...',

	// $ 购物车
	order_cart_page_text_total: 'Gesamt',
	order_cart_page_text_complete_order: 'Die Bestellung der aktuellen Runde ist komplett',
	order_cart_page_text_round_max_order_count: 'Limit der Gänge liegt bei:{{n}}',
	order_cart_page_text_round_max_number_exceed: 'Die Anzahl der möglichen Bestellungen wurde überschritten',
	order_cart_page_text_similar_dish_number_exceed: 'Die Anzahl der Kategorie wurde überschritten',
	order_cart_page_text_same_dish_number_exceed: 'Maximalanzahl des Gerichts überschritten',
	order_cart_page_text_max_rounds_exceed: 'Die Anzahl der Gänge wurde überschritten',
	order_cart_page_text_dish_not_exists: 'Dieses Gericht existiert nicht',
	order_cart_page_text_commit_cart_fail: 'Sendung an den Warenkorb nicht möglich ',
	order_cart_page_text_commit_success: 'Bestellung erfolgreich ',
	order_cart_page_text_cart_not_data: 'Keine Daten vorhanden',
	order_cart_page_text_select_preferences: 'Klicken Sie auf das Gericht, um die Soße auszusuchen',
	order_cart_page_text_disable_edit_second: 'Der nächste Schritt folgt in {{s}} Sekunden',
	order_cart_page_text_print_credential_fail: 'Drucken nicht möglich',
	order_cart_page_text_dish_remarks: ' Anzahl der Gerichte eingeben',
	order_cart_page_text_self: 'Self',
	order_cart_page_text_cannot_at_the_same_time: 'Die Bestellung kann nicht durchgeführt werden, bitte überarbeiten Sie ihre Bestellung',
	order_cart_page_text_is_submitting: 'Bestellung wird gesendet',
	order_cart_page_text_round_rules: 'Sie können es nur einmal pro Runde senden. Sie haben noch einen ungenutzten Betrag. Möchten Sie es wirklich senden?',
	order_cart_page_text_clear: 'Löschen',
	order_cart_page_text_delete: 'Löschen',
	order_cart_page_text_exe_dishes_commit: 'Es gibt überschüssige Gerichte, ob weiterhin einzureichen',
	order_cart_page_text_confirm_modification: 'Bestätigen',
	order_cart_page_text_sync_round_info_success: 'Die Schicht wurde erfolgreich aktualisiert',
    order_cart_page_text_dish_is_sold_out: 'Das Gericht ist ausverkauft.',
    order_cart_page_text_sold_out: 'ausverkauft',
    order_cart_Page_text_verify_sold_out_dishes_message: 'Die Schale \'{{menuName}}\' kann in Mengen von {{excessedNum}} bestellt werden;',

	// $ 点餐
	menu_page_text_please_select_your_id: 'Bitte ID eingeben',
	menu_page_text_check_tip_id: 'Haben Sie Ihre ID vergessen? Bitte überprüfen Sie ihre Bestellung',
	menu_page_text_dishes_copy: 'Das Gericht {{n}} wurde {{1}} mal in diesem Durchgang bestellt',
	menu_page_text_more_than_half_ordered: '{{n}} Personen haben  {{dish}} bestellt',
	menu_page_text_not_show: 'Diese Nachricht nicht mehr anzeigen',
	menu_page_text_under_review_wait: 'Wird überprüft, bitte warten',
	menu_page_text_order_success_created_jump: 'Die Bestellung war nicht erfolgreich, gehe zurück auf die Speisekarte',
	menu_page_text_order_does_not_exist: 'Diese Bestellung existiert nicht oder der Tisch wurde noch nicht freigegeben, versuchen Sie es erneut',
	menu_page_text_review_rejected: 'Überprüfung fehlgeschlagen',
	menu_page_text_under_review: 'Wird überprüft',
	menu_page_text_locked_state: 'Die Bestellung war nicht möglich, wählen Sie etwas anderes aus ',
	menu_page_text_reset_send: ' Anfrage wird überprüft ',
	menu_page_text_reset_send_success: 'Anfrage erfolgreich',
	menu_page_text_approved: ' Angenommen ',
	menu_page_text_order_unlocked: ' Die Bestellung war nicht möglich',
	menu_page_text_table_invalid: 'Tisch nicht gültig',
	menu_page_text_customer_id_occupy: 'Die ID ist schon in Gebrauch',
	menu_page_text_dish_time_disable: 'Einige Gerichte sind wegen der Schließzeiten der Küche nicht verfügbar',
	menu_page_text_notice_time: 'Die Küche schließt in {{time}} Minuten. Bitte bestellen Sie ihr Gericht davor.',
	menu_page_text_allergen_filter_label_message: 'Wählen Sie die zu filternden Gerichte aus',
	menu_page_text_allergen: 'Allergene',
	menu_page_text_ingredents: 'Andere Geschirretiketten',
	menu_page_text_ingredent_filter_label_message: 'Wählen Sie die zu filternden Gerichte aus',
	menu_page_text_filter: 'Filter',
	menu_page_text_dish_exceeded: 'Das Gericht das sie zum Warenkorb hinzufügen übersteigt die Anzahl dieses Artikels. Es können Extrakosten anfallen, wenn Sie die Eingabe fortführen',

	// $ 扫码入口页
	home_page_text_please_select_menu: 'Gericht auswählen',
	home_page_text_number_of_adults: 'Anzahl der Erwachsenen',
	home_page_text_number_of_child: 'Anzahl der Kinder',
	home_page_text_adult_price: 'Preis Erwachsene',
	home_page_text_child_price: 'Preis Kind',
	home_page_text_normal: 'Standart',
	home_page_text_special: 'Spezial',
	home_page_text_table_pause_use: 'Der Tisch ist nicht verfügbar',
	home_page_text_order_now: 'Jetzt bestellen',
	home_page_text_get_menu_fail: 'ie Speisekarte konnte nicht geladen werden, probieren Sie es noch einmal',
	home_page_text_announcement: 'Benachrichtigung',

	// $ 公告页
	notice_page_text_no_picture: 'Kein Bild vorhanden',

	// $ 过敏源种类
	text_gluten: "Gluten",
	text_crustaceans: "Krustentiere",
	text_eggs: "Ei",
	text_fish: "Fisch",
	text_peanuts: "Erdnüsse",
	text_soya: "Soja",
	text_milk: "Milch",
	text_tree_nuts: "Nüsse",
	text_celery: "Sellerie",
	text_mustard: "Senf",
	text_sesame: "Sesam",
	text_sulphites: "Sulfite",
	text_lupin: "Lupinen",
	text_molluscs: "Weichtiere",
	text_mild_spicy: "Mild",
	text_medium_spicy: "Mittelscharf",
	text_very_spicy: "Pikant",
	text_frozen_origin: "Gefroren ",
	text_blast_freezing: "Tiefgefroren",
	text_vegetarian: "Vegetarisch",
	text_vegan: "Vegan",
	text_gluten_free: "Glutenfrei",
	text_raw: "Roh",
	text_cooked: "Gekocht",
	text_additives: "Zusatzstoffe",
	text_colourants: "Farbstoffe",

	// 新手引导
	novice_guide_text_select_menu: 'Wählen Sie ein Menü',
	novice_guide_text_select_normal_menu: 'Standardmenü auswählen',
	novice_guide_text_select_special_menu: 'Spezialmenü auswählen',
	novice_guide_text_select_number_of: 'Anzahl der Gäste eingeben',
	novice_guide_text_order: 'Bestellen',
	novice_guide_text_announcement: 'Benachrichtigungen',
	novice_guide_text_cart: 'Warenkorb',
	novice_guide_text_history: 'Bestellungshistorie',
	novice_guide_text_call: 'Service rufen',
	novice_guide_text_switch_dish_mode: 'Darstellung der Speisekarte ändern',
	novice_guide_text_first_menu: 'Hauptgericht auswählen',
	novice_guide_text_switch_user: 'Aktuellen Benutzer anzeigen',
	novice_guide_text_round_dish: 'Kontrolliere die Anzahl des Gangs',
	novice_guide_text_click_dish_card_add: 'Hier klicken, um das Gericht zu bestellen',
	novice_guide_text_click_dish_card_reduce: "Hier klicken, um das Gericht zu entfernen",
	novice_guide_text_enlarge_dish_card: "Hier klicken, um die Details des Gerichts zu sehen",
	ovice_guide_text_click_cancel: 'Hier klicken, um den Assistenten zu beenden',
	novice_guide_text_reduce_order: 'Bestellung erhöhen',
	novice_guide_text_increase_order: 'Bestellung vermindern',
	novice_guide_text_table: 'Tisch',
	novice_guide_text_enter_number: 'Anzahl der Gäste eingeben',
	novice_guide_text_swipe_to_switch: 'Wischen, um zu wechseln',
	novice_guide_text_home: 'Startseite',

	// 自助开台
	auto_open_page_text_featured_dishes: 'Spezialgerichte',
	auto_open_page_text_order_now: 'Jetzt bestellen',
	auto_open_page_text_opening_hours: 'Mögliche Bestelluhrzeiten',
	auto_open_page_text_media: 'Soziale Medien',
	auto_open_page_text_website: 'Offizielle Website',
	uto_open_page_text_reservation: 'Reservierungen',
	auto_open_page_text_takeaway: 'Zum Mitnehmen',
	auto_open_page_text_without_menu: 'Zurzeit ist kein Gericht wählbar',
	auto_open_page_adults: 'Erwachsene',
	auto_open_page_other: 'Andere',
	auto_open_page_children: 'Kinder',
	auto_open_page_text_menu: 'Speisekarte',
	text_persons: 'Gäste',
	auto_open_page_open_table: 'Tisch eröffnen',
	auto_open_page_select: 'Auswählen',
	auto_open_page_see_more: 'Mehr anzeigen',
	auto_open_page_text_disabled_message: 'Das Öffnen der Selbstbedienungstische ist gesperrt, bitte wenden Sie sich an das Personal.',

	// 临时密码功能
	auto_open_page_text_set_temporary_password: 'Gib einen vorläufigen Pin ein',
	auto_open_page_text_input_temporary_password: 'Bitte Pin eingeben',
	auto_open_page_text_reset_temporary_password: 'Pineingabe wiederholen',
	auto_open_page_text_cancel_temporary_password: 'Pin löschen',
	auto_open_page_text_forgot_password: 'Pin vergessen',
	auto_open_page_text_input_password: 'Geben Sie eine vierstellige Nummer ein',
	auto_open_page_text_go_back: 'Zurück',
	auto_open_page_text_confirm_changes: 'Bestätigen',
	auto_open_page_incorrect_pin: 'Pineingabe falsch',
	auto_open_page_modification_failed: 'Bearbeitung nicht erfolgreich',
	auto_open_page_modification_succeed: 'Bearbeitung erfolgreich',
	auto_open_page_button_confirm: 'Bestätigen',
	auto_open_page_employee_account: 'Nutzer',
	auto_open_page_employee_password: 'Passwort',
	auto_open_page_pin: 'PIN',

	// 复合型营业时间
	general_text_all_day_business: '24 Stunden geöffnet',
	general_text_business_hours: "Feste Arbeitszeiten",
	general_text_compound_business_hours: "Wöchentliche Arbeitszeit",

	// 餐厅区域
	general_text_You_are_not_in_the_restaurant_area_unable_to_order: 'Sie sind nicht im Restaurantbereich, keine Bestellung möglich',
	general_text_Getting_your_location_failed: 'Ihr Standort konnte nicht korrekt abgerufen werden',

	general_text_poor_network: 'Es kann keine Verbindung zum Server oder instabiles Netzwerk hergestellt werden. Bitte versuchen Sie es später erneut',

	// 点餐 - 套餐相关
	menu_page_text_setMenu: 'Menü',
	menu_page_text_choose_the_products: 'Wählen Sie das Produkt',
	menu_page_text_add_to_cart: 'in den Warenkorb legen',
	menu_page_text_set_menu_required: 'erforderlich',
}